export const firebaseSettings = {
  firebaseConfig: {
    apiKey: "AIzaSyB_pu8BBTYQqT4YsgRLzSWnxw9uvEFFJGE",
    authDomain: "funxtion-svt.firebaseapp.com",
    databaseURL: "https://funxtion-svt.firebaseio.com",
    projectId: "funxtion-svt",
    storageBucket: "funxtion-svt.appspot.com",
    messagingSenderId: "661202936753",
    appId: "1:661202936753:web:a1fc9a03bbfca115b79390",
    measurementId: "G-9C7KRR7T2Y",
  },
};
